/**
 * Careers marketing page (`/careers`) — GitHub issue "Create React
 * components for static marketing pages using vite-react-ssg".
 * Statically generated; no client-side data fetching or auth dependency.
 */
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import MarketingLayout from '@/components/marketing/MarketingLayout';
import SeoHead from '@/components/marketing/SeoHead';
import { Button } from '@/components/ui/button';

export default function CareersPage(): JSX.Element {
  const { t } = useTranslation();

  return (
    <MarketingLayout>
      <SeoHead
        title={t('marketing.careers.title')}
        description={t('marketing.careers.description')}
        path="/careers"
      />

      <section className="container mx-auto max-w-3xl px-4 py-16 text-center">
        <h1 className="text-4xl font-bold tracking-tight sm:text-5xl">
          {t('marketing.careers.heading')}
        </h1>
        <p className="mt-4 text-xl text-muted-foreground">{t('marketing.careers.subheading')}</p>
        <p className="mt-8 text-muted-foreground">{t('marketing.careers.empty')}</p>
        <div className="mt-8">
          <Button size="lg" asChild>
            <Link to="/contact">{t('marketing.careers.cta')}</Link>
          </Button>
        </div>
      </section>
    </MarketingLayout>
  );
}
